import invoice_currencies from "./invoice_currencies";

export default { invoice_currencies };
